import { connect } from 'react-redux';
import { setOpenModal } from '../../../store/modals/actions';
import DeleteButton from './DeleteButton';

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),

});

export default connect(null, mapDispatchToProps)(DeleteButton);
